import React from 'react';
import { FEATURE_NOTIFICACION_CORREO_HABILITADA } from '../../featureFlags';

export interface ResultadoGestionModalProps {
  tipo: 'aprobado' | 'rechazado';
  porcentajeRechazados?: number;
  totalRechazados?: number;
  correoDestino?: string;
  estadoNotificacion?: string;
  mensajeNotificacion?: string;
  onClose: () => void;
}

export const ResultadoGestionModal: React.FC<ResultadoGestionModalProps> = ({
  tipo,
  totalRechazados,
  correoDestino,
  estadoNotificacion,
  mensajeNotificacion,
  onClose
}) => {
  const esAprobado = tipo === 'aprobado';
  const colorTema = esAprobado ? '#7cb342' : '#ff5252';
  const tieneFallaCorreo = estadoNotificacion === 'ERROR_ENVIO' || estadoNotificacion === 'CORREO_INVALIDO';

  return (
    <div style={{ 
      padding: '32px 28px 28px', 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box'
    }}>
      {/* Círculo con icono */}
      <div style={{ 
        width: '60px', 
        height: '60px', 
        backgroundColor: colorTema, 
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff',
        fontSize: '30px',
        fontWeight: 'bold',
        marginBottom: '16px',
        boxShadow: `0 4px 12px ${esAprobado ? 'rgba(124, 179, 66, 0.3)' : 'rgba(255, 82, 82, 0.3)'}`
      }}>
        {esAprobado ? '✓' : '✕'}
      </div>
      
      {/* Título */}
      <h3 style={{
        margin: '0',
        fontSize: '20px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
      }}>
        {esAprobado ? 'Gestión Aprobada' : 'Gestión Rechazada'}
      </h3>

      {/* Subtítulo de CUPS rechazados (solo si es rechazado y viene con conteo) */}
      {!esAprobado && typeof totalRechazados === 'number' && totalRechazados > 0 && (
        <span style={{
          fontSize: '13px',
          color: '#718096',
          marginTop: '4px',
          display: 'block'
        }}>
          Rechazaste {totalRechazados} CUPS
        </span>
      )}


      {/* Mensaje descriptivo */}
      <p style={{
        margin: '16px 0 0 0',
        fontSize: '14px',
        color: '#4a5568',
        lineHeight: '1.5',
        maxWidth: '440px'
      }}>
        {esAprobado
          ? 'Su gestión fue aprobada exitosamente. Podrá consultarla en 5 minutos.'
          : 'Le informamos que el anexo fue rechazado. Próximamente, el negociador se comunicará con usted para revisar y acordar nuevas condiciones.'}
      </p>

      {/* Detalle de notificación por correo */}
      {FEATURE_NOTIFICACION_CORREO_HABILITADA && (tieneFallaCorreo ? (
        <p style={{
          margin: '16px 0 0 0',
          fontSize: '13px',
          color: '#e53e3e',
          lineHeight: '1.4',
          maxWidth: '440px'
        }}>
          Sin embargo, no fue posible enviar el correo de notificación: {mensajeNotificacion || 'Error en el servicio de mensajería.'}
        </p>
      ) : correoDestino ? (
        <p style={{
          margin: '16px 0 0 0',
          fontSize: '13px',
          color: '#4a5568',
          lineHeight: '1.4',
          maxWidth: '440px'
        }}>
          {esAprobado
            ? <>Hemos enviado un correo de confirmación a <strong>{correoDestino}</strong></>
            : <>Hemos enviado una notificación al correo <strong>{correoDestino}</strong></>}
        </p>
      ) : null)}

      {/* Botón Aceptar */}
      <button
        onClick={onClose}
        style={{
          marginTop: '22px',
          padding: '10px 42px',
          backgroundColor: colorTema,
          color: '#ffffff',
          border: 'none',
          borderRadius: '6px',
          fontSize: '15px',
          fontWeight: '600',
          cursor: 'pointer',
          boxShadow: `0 4px 10px ${esAprobado ? 'rgba(124, 179, 66, 0.25)' : 'rgba(255, 82, 82, 0.25)'}`,
          transition: 'opacity 0.2s',
          minWidth: '120px'
        }}
        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
      >
        Aceptar
      </button>
    </div>
  );
};

export default ResultadoGestionModal;

